module.exports = __webpack_public_path__ + "static/media/user_input.3785a4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FruitTool/user_input.png
// module id = 2538
// module chunks = 0